<script>
import PopulationEditForm from './PopulationEditForm';
import Overlay from '../../../../components/Overlay';
import { mapActions } from 'vuex';


export default {
    components: { Overlay, PopulationEditForm },

    data() {
        return {
            fieldId: null
        };
    },

    mounted() {
        this.getData();
        this.fieldId = this.$route.params.fieldToPopulate;
    },

    methods: {
        ...mapActions({
            showNotification: 'notification/show',
            getData: 'populationEditor/getData',
            saveData: 'populationEditor/saveData'
        })
    }
};
</script>

<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                md="11"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Create Population</h1>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="12"
                md="11"
                justify="center"
            >
                <PopulationEditForm />
            </v-col>
        </v-row>
    </v-container>
</template>